import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3e3385ae"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "video-player-page"
};
var _hoisted_2 = {
  class: "video-container"
};
var _hoisted_3 = {
  key: 0,
  class: "error提示"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "⚠️ 视频加载失败，请检查视频文件是否存在", -1);
});

var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "video-info"
};
var _hoisted_7 = {
  class: "video-title"
};
var _hoisted_8 = {
  class: "video-desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
    class: "back-btn",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$router.go(-1);
    })
  }, "← 返回列表"), _createElementVNode("div", _hoisted_2, [$data.isError ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("p", null, "路径：" + _toDisplayString($data.currentVideoUrl), 1)])) : (_openBlock(), _createElementBlock("video", {
    key: 1,
    src: $data.currentVideoUrl,
    controls: "",
    class: "video-player",
    poster: "/images/video-cover.jpg",
    onError: _cache[1] || (_cache[1] = function () {
      return $options.handleVideoError && $options.handleVideoError.apply($options, arguments);
    })
  }, " 您的浏览器不支持HTML5视频播放，请更换浏览器后重试。 ", 40, _hoisted_5)), _createElementVNode("div", _hoisted_6, [_createElementVNode("h2", _hoisted_7, _toDisplayString($data.currentVideo.title), 1), _createElementVNode("p", _hoisted_8, _toDisplayString($data.currentVideo.desc), 1)])])]);
}